import { GET_ERRORS, CLEAR_ERRORS, CLEAR_ERROR_ON_HANDLE_CHANGE, GET_CUSTOM_ERRORS } from '../actions/types'

const initialState = {}

const errorReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ERRORS:
      return {}
    case GET_ERRORS:
      return action.payload
    case GET_CUSTOM_ERRORS:
      return {
        ...state,
        ...action.payload,
      }
    case CLEAR_ERROR_ON_HANDLE_CHANGE:
      return { ...state, error: { ...state.error, [action.payload]: false } }
    default:
      return state
  }
}

export default errorReducer
